<template>
  <div>
    <header-page :namePage="$t('pagesTitles.mc')" :links="$store.state.headerLinks.supervisorMcLinks"/>
    <div class="content status">
      <div class="status__title">
        <h2>{{$t('mc.supervisor.titles.statusMimk')}}</h2>
        <div class="status__select">
        <v-select  
          @open="choiseTimeslot"
          @close="choiseTimeslot"
          v-model="time" 
          :searchable="false"
          :clearable="false"
          :options="statusTime" 
          label="title"
          class="style-chooser">
          <template #header>
            <span class="status__time">{{time.title}}</span>
          </template>
        </v-select>
        </div>
        <inline-svg
        :class="[{'status__arrow_active': activeSelectArrow}, 'status__arrow']"
          :src="require(`@/assets/svg/select-arrow.svg`)"
        />
      </div>
      <SearchDropdown 
        ref="searchDropdown"
        @sortTable="sortTable" 
        @dropAllOptions="dropAllOptions"
      />
      <loader v-if="isLoad"/>
      <template v-if="mimkList.length && !isLoad">
        <base-table
          :alignLeft="true"
          :head="table.head"
          :columnTemplates="table.sizeColumn">
          <base-table-row
            v-for="(element) of mimkList[this.page-1]"
            :key="`${element.id}mimk-status`"
            :columnTemplates="table.sizeColumn"
            :style="mimksTags && Array.isArray(mimksTags[element.id]) && mimksTags[element.id].length ? 'position: relative; padding-bottom: 40px;' : ''"
          >
            <base-table-column class="content-left">
              {{element.label || element.full_name}}
            </base-table-column>
            <base-table-column class="content-left">
              <span>{{element.rating}}</span>
            </base-table-column>
            <base-table-column class="content-left">
              <div class="flex" v-if="element.status">
                <div class="status-square" :style="{ background: statusColor(element.status)}"></div>
                <span>{{$t(element.title)}}</span>
              </div>
            </base-table-column>
            <div style="position: absolute;bottom: 0;padding-left: 15px;" v-if="mimksTags[element.id]">
              <Tags :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);" :prop-tags="mimksTags[element.id]"></Tags>
            </div>
          </base-table-row>
        </base-table>
          <pagination
            v-model="page"
            :records="storeMimkList.length"
            :per-page="8"
            :options="{texts: false}"
          />
      </template>
      <loader v-else></loader>
      <div class="empty-mk-title" v-if="!mimkList.length && !isLoad">{{$t('mc.supervisor.statusMimk.notFound')}}  
        <span v-if="countOfStatus === 1">{{$t('mc.supervisor.statusMimk.notFoundOne')}}</span>
        <span v-else>{{$t('mc.supervisor.statusMimk.notFoundMoreOne')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import apiMimk from '@/api/master-classes/mimk'
import tagsApi from "@/api/tags";
import  militaryAndLanguage from "@/helpers/militaryAndLanguage"
import createSubarrays from "@/helpers/createSubarrays"
import {statusColor} from '@/helpers/changeStatuses'
import {timePeriod} from '@/helpers/timeForSelect'
import SearchDropdown from '@/components/Supervisor/SearchStatusOptions'
import Tags from "@/components/Supervisor/Tags";
export default {
   data() {
    return {  
      storeMimkList: [],
      militaryAndLanguage,
      isLoad: false,
      statusColor,
      status: 'Статус',
      table: {
        head: [
          this.$t('mc.tables.titles.mimk'), 
          this.$t('mc.tables.titles.rate'), 
          this.$t('mc.tables.titles.status')],
        sizeColumn: '1fr 1fr 2fr'
      },
      timePeriod,
      statusTime: [],
      time : {},
      fetchedTime: '',
      activeSelectArrow: false,
      countOfStatus: null,
      page: 1,
      choiseTimeListMimk: []
    }
  },
  components: {
    SearchDropdown,
    Tags,
  },
  //Получаем текущий час и прибавляем к нему 1 час для вывода на страницу времени вида 12:00-13:00 и присваиваем в this.time.title
  created() {
    this.initMain()
  },
  methods: {
    initMain() {
      this.formatTimeOnLoad()
      this.storeMimkList = this.storeMimks
      this.getMimkTags()
      this.createVievStatuses(this.storeMimkList)
    },
    getMimkTags() {
      if (this.storeMimkList.length) tagsApi.getMimksTags(this.storeMimkList.map(el => el.id), this.$store.state.user.segment.id, true)
    },
    createVievStatuses(mimkArray) {
      mimkArray.forEach(el => {
        for (const matchedElement in this.$store.state.statuses.mimkStatuses) {
          if (el.status === this.$store.state.statuses.mimkStatuses[matchedElement].statusMatch) {
            el.title = this.$store.state.statuses.mimkStatuses[matchedElement].translateStatusTitle
          }
        }
      })
    },
    formatTimeOnLoad() {
      const localTime = this.$store.state.user.segment.segment_local_time
      if (this.isMilitaryTime) this.statusTime = this.timePeriod
      else {
        this.statusTime = this.timePeriod.map(timePeriodEl => {
          const firstTime = timePeriodEl.title.slice(0,5)
          const secondTime = timePeriodEl.title.slice(7,13)
          return { title: `${this.$dayjs(firstTime, 'HH:mm').format('hh:mm a')} - ${this.$dayjs(secondTime, 'HH:mm').format('hh:mm a')}`}
        })
      }
      let currentTime = ''
      let plusHourTime = ''
      let title = ''
      const formatTimeToMeridian = (time) => {
        let timeStringToArray = time.split('')
        timeStringToArray.splice(2, 0 , ':00')
        return timeStringToArray.join('')
      }
      if (this.isMilitaryTime) {
        currentTime = this.$dayjs(localTime).format('HH')
        plusHourTime = this.$dayjs(localTime).add(1, 'hour').format('HH')
        title = `${currentTime}:00 - ${plusHourTime}:00`
      } else {
        currentTime = formatTimeToMeridian(this.$dayjs(localTime).format('hh a'))
        plusHourTime = formatTimeToMeridian(this.$dayjs(localTime).add(1, 'hour').format('hh a'))
        title = `${currentTime} - ${plusHourTime}`
      }
      this.time.title = title
    },
    //Эмит из компонента SearchStatusOption в котором мы сбрасываем все выбранные опции , здесь сбрасываем пагинацию на 1 страницу
    dropAllOptions() {
      this.page = 1
      //Проверяем если было выбранно время значит в this.mimkList добавляем список мимков из this.choiseTimeListMimk
      this.mimkList = this.$store.state.user.mimkList
    },
    //При нажатии на время показываем селект с выбором временных промежутков
    choiseTimeslot() {
      this.activeSelectArrow = !this.activeSelectArrow
    },
    sortTable(optionsArray) {
      //Принимаем опции с выбранными статусами для сортировки
      this.isLoad = true
      //Колличество выбранных статусов МИМК
      this.countOfStatus = optionsArray.length
      //
      let newTableArray = []
      //Фильтруем МИМКов по статусам приходящим из из компонента с сортировкой
       this.$store.state.user.mimkList.filter(tableElement => {
        optionsArray.forEach(cameElement => {
          if (tableElement.status === cameElement.match) {
            newTableArray.push(tableElement)
          }
        });
      })
      //Добавляем на в таблицу отсортированный список МИМКов
      this.mimkList = newTableArray
      this.page = 1
      this.isLoad = false
    }
  },
  computed: {
    storeMimks() {
      return this.$store.state.user.mimkList
    },
    mimksTags() {
      return this.$store.state.tags.mimksTagsObject
    },
    isMilitaryTime() {
      let military = null
      military = this.militaryAndLanguage()
      return military
    },
    //геттер и сеттер в котрые сетим новые данные и пагинируем в геттере 
    mimkList: {
      get () {
        return createSubarrays(8, this.storeMimkList)
      }, 
      set (newValue) {
        return this.storeMimkList = newValue
      }
    },
  },
  watch: {
    storeMimks() {
      this.initMain()
    },
    //Ватчер срабатываемый при изменении дропдауна со временем
    async time(timeValue) {
      this.isLoad = true
      //Сбрасываем все опции в компоненте SearchStatusOptions
      this.$refs.searchDropdown.dropAllOptions()
      //Слайсим время оставляя только начальное для получения времени которое будем отправлять на сервер
      //и приводим время в нужный формат для эндпоинта
       let formatTimeToFetch = ''
      if (this.isMilitaryTime) {
        formatTimeToFetch = `${this.$dayjs(timeValue.title.slice(0,5), 'HH:mm').format('YYYY-MM-DD HH')}:00`
      }
      else {
        formatTimeToFetch = `${this.$dayjs(timeValue.title.slice(0,8), 'hh:mm a').format('YYYY-MM-DD HH')}:00`
      }
      //Добавляем полученные данные в массив this.mimkList
      let choisenTimeListMimk = await apiMimk.getMimkStatus(formatTimeToFetch)
      this.$store.commit('user/setMimkList', choisenTimeListMimk)
      this.storeMimkList = this.$store.state.user.mimkList
      this.createVievStatuses(this.storeMimkList)
      this.isLoad = false
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

.status-select {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 108px;
  background: #fff;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
}
.style-chooser::v-deep .vs__dropdown-toggle {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 120%;
}
.status-square {
  width: 25px;
  height: 25px;
  margin-right: 14px;
}
.time-select {
  max-width: 300px;
}
.status {
  &__time {
    margin-left: 10px;
    font-weight: 600;
    font-size: 24px;
    color: var(--main-blue);
  }
  &__title {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }
  &__arrow {
    margin-left: 8px;
    &_active {
      transform: rotate(180deg);
    }
  }

}
</style>